import { render, staticRenderFns } from "./TiktokResources.vue?vue&type=template&id=49dcfecf&scoped=true"
import script from "./TiktokResources.vue?vue&type=script&lang=js"
export * from "./TiktokResources.vue?vue&type=script&lang=js"
import style0 from "./TiktokResources.vue?vue&type=style&index=0&id=49dcfecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dcfecf",
  null
  
)

export default component.exports